exports = module.exports = require("../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".agency-rating{font-size:1.35rem;color:#ffd203}.agency-rating.small{font-size:.85rem}", ""]);

// exports
